export default "__VITE_ASSET__xxbZVriW__"